import Vue from "vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)

import {
  faArrowLeft, faArrowRight, faChevronRight, faCheck, faLock, faSpinner, faUser, faTriangleExclamation, faTimes,
  faAngleDown, faImage, faSignature, faPlus, faFilePdf
} from '@fortawesome/free-solid-svg-icons'

library.add(faArrowLeft)
library.add(faArrowRight)
library.add(faChevronRight)
library.add(faUser)
library.add(faLock)
library.add(faCheck)
library.add(faSpinner)
library.add(faTriangleExclamation)
library.add(faTimes)
library.add(faAngleDown)
library.add(faImage)
library.add(faPlus)
library.add(faSignature)
library.add(faFilePdf)
